import { Pipe, PipeTransform } from '@angular/core';
import { RabatTypeEnum } from '../api/models/OK/Egis/Service/Models/ValueObjects/rabat-type-enum';

@Pipe({
    name: 'rabatType',
    standalone: false
})
export class RabatTypePipe implements PipeTransform {
  transform(value: RabatTypeEnum) {
    switch (value) {
      case RabatTypeEnum.NoRabat:
        return 'Ingen rabat';
      case RabatTypeEnum.KontantEngangsRabat:
        return 'Kontant engangsrabat';
      case RabatTypeEnum.ProcentEngangsRabat:
        return 'Procentvis engangsrabat';
      case RabatTypeEnum.RecurringKontantRabat:
        return 'Kontantrabat';
      case RabatTypeEnum.RecurringProcentRabat:
        return 'Procentrabat';
    }
    return value;
  }
}
